import { Translator } from '@/types/translator.type';

export const BENEFIT_MARGIN_RATE_LABEL = (t: Translator) =>
  t('benefits.marginRate');

export const SUPPLIER_MARGIN_RATE_LABEL = (t: Translator) =>
  t('suppliers.marginRateLabel');

export const CIRCUIT_MARGIN_RATE_LABEL = (t: Translator) =>
  t('circuits.marginRateLabel');
